'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var styled = require('@emotion/styled');
var coreRenderer = require('@tempi/core-renderer');
var React = require('react');
var getIconComponent = require('../../../utils/getIconComponent.js');
var SpinningInner = require('../../../core/Spin/SpinningInner.js');
var Ripple = require('../../../core/Ripple/Ripple.js');
var index = require('../../../core/Link/index.js');
var fonts = require('../../../constants/fonts.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const ButtonV2 = React__default["default"].forwardRef(
  (props, ref) => {
    const _a = props, {
      commonStyle,
      text,
      iconConfig,
      isEditingMode = false,
      onClick,
      className,
      disabled,
      buttonStyle,
      customText,
      event,
      loading
    } = _a, rest = __objRest(_a, [
      "commonStyle",
      "text",
      "iconConfig",
      "isEditingMode",
      "onClick",
      "className",
      "disabled",
      "buttonStyle",
      "customText",
      "event",
      "loading"
    ]);
    const IconComponent = getIconComponent.getIconCompoment(iconConfig == null ? void 0 : iconConfig.icon);
    const hasPrefix = (iconConfig == null ? void 0 : iconConfig.show) && (iconConfig == null ? void 0 : iconConfig.position) === "left" && !!IconComponent;
    const hasSuffix = (iconConfig == null ? void 0 : iconConfig.show) && (iconConfig == null ? void 0 : iconConfig.position) === "right" && !!IconComponent;
    const isDisableBtn = disabled || loading;
    const btn = /* @__PURE__ */ jsxRuntime.jsxs(StyledButton, __spreadProps(__spreadValues({
      ref,
      disabled: isDisableBtn,
      buttonStyle,
      onClick: (e) => {
        if (typeof onClick === "function" && !isDisableBtn && !isEditingMode) {
          e.preventDefault();
          onClick();
        }
      }
    }, rest), {
      children: [
        loading && /* @__PURE__ */ jsxRuntime.jsx("span", {
          children: /* @__PURE__ */ jsxRuntime.jsx(SpinningInner.StyledSpinningInner, {
            size: 10,
            transform: 5,
            time: 0.6
          })
        }),
        hasPrefix && !loading && IconComponent,
        /* @__PURE__ */ jsxRuntime.jsx("span", {
          style: __spreadValues(__spreadValues({}, (hasPrefix || loading) && !!text && {
            marginLeft: iconConfig == null ? void 0 : iconConfig.spacing
          }), !!hasSuffix && !!text && {
            marginRight: iconConfig == null ? void 0 : iconConfig.spacing
          }),
          children: customText ? customText : /* @__PURE__ */ jsxRuntime.jsx("span", {
            dangerouslySetInnerHTML: { __html: text }
          })
        }),
        hasSuffix && IconComponent,
        !disabled && !customText && /* @__PURE__ */ jsxRuntime.jsx(Ripple.Ripple, {})
      ]
    }));
    if (isEditingMode) {
      return /* @__PURE__ */ jsxRuntime.jsx(ButtonWrapper, {
        commonStyle,
        className,
        children: btn
      });
    }
    return /* @__PURE__ */ jsxRuntime.jsx(ButtonWrapper, {
      commonStyle,
      className,
      children: /* @__PURE__ */ jsxRuntime.jsx(index.Link, __spreadProps(__spreadValues({}, event), {
        children: btn
      }))
    });
  }
);
const StyledButton = styled__default["default"].button(
  ({ buttonStyle }) => `
    ${fonts.getCommonTextCss()}
    position: relative;
    border: none;
    align-items: center;
    text-decoration: none;
    display: flex;
    cursor: pointer;
    justify-content: center;
    font-size: 14px;
    line-height: 16px;
    background: transparent;
    > span {
      font-size: inherit;
      line-height: inherit;
    }
    &[disabled] {
      color: #00000040;
      border-color: #d9d9d9;
      background: #f5f5f5;
      text-shadow: none;
      box-shadow: none;
      cursor: not-allowed;
    }
    ${coreRenderer.getStyle(buttonStyle)}
`
);
const ButtonWrapper = styled__default["default"].div(
  ({ commonStyle }) => `
  display: flex;
  width: 100%;
  position: relative;
  ${coreRenderer.getStyle(commonStyle)}
`
);
ButtonV2.displayName = "ButtonV2";

exports.ButtonV2 = ButtonV2;
exports.ButtonWrapper = ButtonWrapper;
